// extracted by mini-css-extract-plugin
module.exports = {"container":"ClassView_container__2ZxMu","containerSidebar":"ClassView_containerSidebar__2_k7A","classEditForm":"ClassView_classEditForm__3EwBr"};